import React, { PureComponent } from "react";
import { Icon } from "../../icons/icon";
import styled from "styled-components";
// import { Divider } from "./divider";
// tslint:disable: match-default-export-name
import DateList from "./date-list";
// import posed from "react-pose";
import { AbstractTimelineContext } from "../abstract-timeline";
import { TIME_LINE_HEIGHT } from "./config";
import smoothscroll from "smoothscroll-polyfill";
import { StyleScrollBarHidden } from "../../styles/style-scrollbar-hidden";
smoothscroll.polyfill();
// tslint:disable: variable-name
const ScreenRoot = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: ${TIME_LINE_HEIGHT}px;
`;
const ScreenContainer = styled.div `
  flex: 1;
  display: flex;
  justify-content: space-between;
  height: 100%;
`;
const DateListContainerStyle = styled.div `
  flex: 1;
  position: relative;
  overflow: hidden;
  height: ${TIME_LINE_HEIGHT}px;
`;
const DateListContent = styled(StyleScrollBarHidden) `
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: ${TIME_LINE_HEIGHT}px;
  width: 100%;
  box-sizing: content-box;
  overflow-x: scroll;
  scroll-behavior: smooth;
`;
const IconStyle = styled.div `
  position: relative;
  z-index: 1;
  font-size: 17px;
  flex: 0 0 36px;
  width: 24px;
  margin: 0 8px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover{
    color:${p => p.hightLightColor};
  }
  user-select: none;
`;
const IconStyleLeft = styled(IconStyle) `
  /* box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12), 0 0 4px 0 rgba(0, 0, 0, 0.06); */
`;
const IconStyleRight = styled(IconStyle) `
  /* box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12), 0 0 4px 0 rgba(0, 0, 0, 0.06); */
`;
/**
 * 滚动屏幕
 *
 * @author 张卓诚
 * @export
 * @class Screen
 * @extends {PureComponent<ScreenProps>}
 * @implements {Color}
 */
export class Screen extends PureComponent {
    constructor() {
        super(...arguments);
        /** 内容向左滑动 */
        this.scrollLeft = (step) => {
            this.DateListRef &&
                this.DateListRef.scrollBy({
                    top: 0,
                    left: -step,
                    behavior: "smooth",
                });
        };
        /** 内容向右滑动 */
        this.scrollRight = (step) => {
            this.DateListRef &&
                this.DateListRef.scrollBy({
                    top: 0,
                    left: step,
                    behavior: "smooth",
                });
        };
    }
    render() {
        const { scrollStep } = this.props;
        return (React.createElement(ScreenRoot, null,
            React.createElement(ScreenContainer, null,
                React.createElement(IconStyleLeft
                // tslint:disable: jsx-no-lambda
                , { 
                    // tslint:disable: jsx-no-lambda
                    onClick: () => this.scrollLeft(scrollStep), color: this.props.colorPalette.mainColor[2], hightLightColor: this.props.colorPalette.mainColor[1] },
                    React.createElement(Icon, null, "left")),
                React.createElement(DateListContainerStyle, null,
                    React.createElement(DateListContent, { ref: node => (this.DateListRef = node) },
                        React.createElement(AbstractTimelineContext.Consumer, null, 
                        // tslint:disable-next-line: jsx-no-multiline-js
                        data => (React.createElement(DateList, Object.assign({}, Object.assign({}, data, { elapses: undefined }), { key: "key", colorPalette: this.props.colorPalette })))))),
                React.createElement(IconStyleRight, { color: this.props.colorPalette.mainColor[2], hightLightColor: this.props.colorPalette.mainColor[1], onClick: () => this.scrollRight(scrollStep) },
                    React.createElement(Icon, null, "right")))));
    }
}
//# sourceMappingURL=screen.js.map